import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { AuthAPI } from "../api/auth";
import { userKeys } from "./use-user";
import { useTranslation } from "@/features/utils/i18n";

export function useCreateApiKey() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation<
    { success: boolean; secret: string },
    Error,
    { name: string }
  >({
    mutationFn: AuthAPI.createApiKey,
    onSuccess: () => {
      // Invalidate user queries to refresh the user data
      queryClient.invalidateQueries({ queryKey: userKeys.all });
      toast.success(t("security.messages.apiKeyCreated"));
    },
  });
}

export function useRemoveApiKey() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  return useMutation<{ success: boolean }, Error, { secret: string }>({
    mutationFn: AuthAPI.removeApiKey,
    onSuccess: () => {
      // Invalidate user queries to refresh the user data
      queryClient.invalidateQueries({ queryKey: userKeys.all });
      toast.success(t("security.messages.apiKeyRemoved"));
    },
  });
}
